import GameSet from '@/api/administrator/game-set'
import GameSetting from '@/api/administrator/game-setting'
import Liability from '@/api/report/liability'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  preview(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage
      },
      attrubutes
    )

    return Liability.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return Liability.store(data)
  },
  getGameSet(context, attrubutes= {}) {
    return GameSet.get({
      params: {
        filter: {
          between_result_date: true,
          game_setting_id: attrubutes.game_setting_id
        },
        fields: {
          game_sets: 'game_set_id,game_set_name'
        },
        page: -1,
        ...attrubutes
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGameSetting(context) {
    return GameSetting.get({
      params: {
        fields: {
          game_settings: 'game_setting,game_setting_id,game_type_id'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
